import React, { ReactNode } from 'react';
import { BUTTON_TYPE } from '../../models/Button';
import './Button.scss';

interface ButtonProps {
    children: ReactNode;
    disabled?: boolean;
    onClick?: (event: any) => any;
    type?: BUTTON_TYPE;
    className?: string,
}

const Button = ({
                    children,
                    className,
                    onClick = () => {
                    },
                    disabled = false,
                    type = BUTTON_TYPE.BUTTON,
                }: ButtonProps) => {

    return (
        <button
            onClick={onClick}
            type={type}
            disabled={disabled}
            className={`bg-primary text-white text-base x rounded font-bold py-2.5 px-5 flex 
            items-center justify-center gap-4 border border-primary w-full lg:w-[80%] mt-auto ${className}`}
        >
            {children}
        </button>
    );
};

export default Button;